import { getStore } from '../redux/store' 
import { reset } from '../redux/app/actions'

const store = getStore()

otuApp.reset = () => {
  store.dispatch( reset() )
}